<template>
	<div class="import-box">
		<el-form :model="form" ref="form" labelPosition="right" autoComplete="on" labelWidth="120px">
			<el-form-item prop="customerId" label="导入文件：">
				 <el-upload
					action=""
					drag
					:multiple="false"
					:limit="1"
					:http-request="(res) => { return httpRequestFile(res)}"
					accept="
						.xls,
						.xlsx">
					<i class="el-icon-upload"></i>
					<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
					<el-link :href="`${cdnUrl}/static/excel/sms_temp.xlsx`" slot="tip" type="primary">下载导入文件模板</el-link>
				</el-upload>
			</el-form-item>
			<el-form-item prop="remark" label="备注：">
				<el-input v-model="form.remark" :rows="4" type="textarea" placeholder="请输入备注" clearable></el-input>
			</el-form-item>
			<el-divider></el-divider>
			<el-form-item style="float: right;padding-right: 30px;">
				<el-button @click.stop="handleSave" :loading="loading" size="mini" type="primary">确 定</el-button>
			</el-form-item>
		</el-form>
    </div>
</template>

<script>
export default {
	data() {
		return {
			cdnUrl: process.env.VUE_APP_BASE_CDN,
           form: {
			   file_content: '',
			   file_name: '',
			   remark: ''
		   },
		   loading: false
		}
    },
	methods: {
		handleSave() {
			 this.$refs["form"].validate(valid => {
                if (valid) {
                    this.loading = true;
					const formData = new FormData();
					formData.append("remark", this.form.remark);
					formData.append("FILE_NAME", this.form.file_name);
					formData.append('FILE_CONTENT', this.form.file_content);
                    this.$api.apiPostSmsImportCustomer(formData).then(response => {
						if(response.errcode != 0) return;
						this.$emit('onEmitCustomerData', response.data);
						this.loading = false;
                    }).catch(error => {
						this.loading = false;
					});
                }
            });
		},
		httpRequestFile(file) {
			this.form.file_name = file?.file?.name;
			this.form.file_content = file.file;
			console.log(this.form, file)
		}
    }
}
</script>

<style lang="scss" scoped>
.import-box{
	padding: 0 15px;
	box-sizing: border-box;
}
</style>